import sal from 'sal.js';

const showMoreBtn = document.querySelector('.btn-showmore');

let currentlyDisplaying = 24;

if (showMoreBtn) {
	showMoreBtn.addEventListener('click', () => {
		currentlyDisplaying += 24;
		const teamCards = document.querySelectorAll('.team-card__wrapper');

		// eslint-disable-next-line no-console
		console.log(teamCards.length);

		teamCards.forEach((card, index) => {
			if (index < currentlyDisplaying) {
				card.classList.remove('d-none');
			}
			if (currentlyDisplaying >= teamCards.length) {
				showMoreBtn.classList.add('d-none');
			}
		});
	});
}

sal();
